"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var MeetingSettingItem = function MeetingSettingItem(_ref) {
  var title = _ref.title,
      options = _ref.options,
      errorText = _ref.errorText,
      description = _ref.description,
      onUpdate = _ref.onUpdate,
      children = _ref.children,
      isLoading = _ref.isLoading,
      renderItems = _ref.renderItems,
      selectProps = (0, _objectWithoutProperties2.default)(_ref, ["title", "options", "errorText", "description", "onUpdate", "children", "isLoading", "renderItems"]);
  var handleUpdate = (0, _react.useCallback)(function (_ref2) {
    var newValue = _ref2.newValue;
    return onUpdate(newValue);
  }, [onUpdate]);
  var renderSelectItems = (0, _react.useMemo)(function () {
    if (!renderItems) {
      return function () {
        return options.map(function (option) {
          return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
            disabled: option.disabled || false,
            key: option.id,
            value: option.id
          }, option.name);
        });
      };
    }

    return renderItems;
  }, [renderItems, options]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1,
    ml: 3,
    mr: 3
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Label-Table-Left-Static"
  }, title), description && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static"
  }, description), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1,
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1 / 2,
    mr: 3
  }, /*#__PURE__*/_react.default.createElement(_ui.SelectFilter, (0, _extends2.default)({
    fullWidth: true,
    error: !!errorText,
    helperText: errorText,
    margin: "normal",
    onFilterChange: handleUpdate,
    renderItems: renderSelectItems,
    name: "newValue",
    disabled: isLoading
  }, selectProps))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1 / 2
  }, children)), /*#__PURE__*/_react.default.createElement(_ui.Divider, {
    mt: 2,
    mb: 2
  })));
};

var _default = /*#__PURE__*/(0, _react.memo)(MeetingSettingItem);

exports.default = _default;